export const codePaths = {
	EDUCATION: "education",
	DEPARTMENT: "department",
	SECTION: "section",
	TITLE: "title",
	RANK: "rank",
	APPLICANT_STATUS: "applicant-status",
	APPLICANT_TEST_RESULT: "applicant-test-result",
	EMPLOYMENT_STATUS: "employment-status",
	TRAINING_COST: "training-cost",
	Relationship: "relationship",
	VehicleStatus: "vehicle-status",
	WorkOrderTypes: "work-order-types",
	WorkOrderStatus: "work-order-status",
	EquipmentTypes: "equipment-types",
	EquipmentStatus: "equipment-status",
	EquipmentConditions: "equipment-conditions",
	EquipmentCategory: "equipment-category",
	InspectionTypes: "inspection-types",
	VehicleServiceRequirements: "vehicle-service-requirements",
	EquipmentServiceRequirements: "equipment-service-requirements",
};

export const securityPaths = {
	PROFILE: "profiles",
	ROLEANDPERMISSION: "roles-permissions",
};

export const FLSAOptions = {
	EXEMPT: "Exempt",
	NON_EXEMPT: "Non Exempt",
};

export const RehireOptions = {
	OK: "OK to rehire",
	NOT_OK: "Do not rehire",
};

export const ImageTypes = {
	Path: "Path",
	Binary: "Binary",
};

export const InputComponentType = {
	TextField: "TextField",
	DatePicker: "DatePicker",
	Dropdown: "Dropdown",
	Checkbox: "Checkbox",
	Radio: "Radio",
	FreeTextDropdown: "FreeTextDropdown",
};

export const customIdPaths = {
	EMPLOYEE_ID: "employee-id",
	COURSE_ID: "course-id",
	CERTIFICATE_ID: "certificate-id",
	PARTICIPANT_ID: "participant-id",
	FLEET_ID: "fleet-id",
	WORKORDER_ID: "work-order-id",
	INSPECTION_ID: "inspection-id",
	FUNDINGSOURCE_ID: "funding-source-id",
	EQUIPMENT_ID: "equipment-id",
	MAINTENANCE_ID: "maintenance-id",
	DISPENSABLE_ID: "dispensable-id",
};

export const perNotesOptions = {
	Employees: "Employees",
	Applicants: "Applicants",
};

export const createRecordFor = {
	Employee: "employee",
	Applicant: "applicant",
};

export const PerTagType = {
	Employee: "perPersonnel",
	Applicant: "perApplicant",
	Course: "trainingCourse",
	Participant: "trainingParticipant",
	Certification: "trainingCertification",
};

export const PerPhotoType = {
	Employee: "perPersonnel",
	Applicant: "perApplicant",
	Inspection: "perInspection",
};

export const routeToModuleMap = {
	"/employee": { area: "modules", key: "Employees" },
	"/applicants": { area: "modules", key: "Applicants" },
	"/code-settings": { area: "modules", key: "Codes" },
	"/security": { area: "modules", key: "Security" },

	"/training/courses": { area: "training", key: "Courses" },
	"/training/certifications": { area: "training", key: "Certifications" },
	"/training/participants": { area: "training", key: "Participants" },
	"/training/summary": { area: "training", key: "Summary" },
	"/training/mass-update": { area: "training", key: "Mass Update" },

	"/code-settings/department": { area: "codes", key: "Department" },
	"/code-settings/rank": { area: "codes", key: "Rank" },
	"/code-settings/training-cost": { area: "codes", key: "Training Cost" },
	"/code-settings/title": { area: "codes", key: "Title" },
	"/code-settings/section": { area: "codes", key: "Section" },
	"/code-settings/employment-status": {
		area: "codes",
		key: "Employment Status",
	},
	"/code-settings/education": { area: "codes", key: "Education" },
	"/code-settings/applicant-status": {
		area: "codes",
		key: "Applicant Status",
	},
	"/code-settings/applicant-test-result": {
		area: "codes",
		key: "Applicant Test Result",
	},
	"/code-settings/relationship": {
		area: "codes",
		key: "Relationship",
	},
	"/security/profiles": { area: "security", key: "Profiles" },
	"/security/roles-permissions": {
		area: "security",
		key: "Roles And Permissions",
	},

	"/asset-sentinel/fleet-vehicles": { area: "fleet", key: "Vehicles" },
	"/asset-sentinel/fleet-work-orders": { area: "fleet", key: "Work Orders" },
	"/asset-sentinel/fleet-inspection": { area: "fleet", key: "Inspections" },
	"/asset-sentinel/fleet-inspection-setup": {
		area: "fleet",
		key: "Inspections Setup",
	},
	"/asset-sentinel/fleet-code-maintenance": {
		area: "fleet",
		key: "Code Maintenance",
	},
	"/asset-sentinel/fleet-funding-sources": {
		area: "fleet",
		key: "Funding Sources",
	},
	"/asset-sentinel/fleet-code-maintenance/vehicle-status": {
		area: "codes",
		key: "Vehicle Statuses",
	},
	"/asset-sentinel/fleet-code-maintenance/work-order-types": {
		area: "codes",
		key: "Work Order Types",
	},
	"/asset-sentinel/fleet-code-maintenance/work-order-status": {
		area: "codes",
		key: "Work Order Statuses",
	},
	"/asset-sentinel/fleet-code-maintenance/vehicle-service-requirements": {
		area: "codes",
		key: "Vehicle Service Requirements",
	},

	"/asset-sentinel/equipment": { area: "equipment", key: "Equipment" },
	"/asset-sentinel/equipment-maintenance": {
		area: "equipment",
		key: "Maintenance",
	},
	"/asset-sentinel/equipment-code-maintenance": {
		area: "equipment",
		key: "Code Maintenance",
	},
	"/asset-sentinel/equipment-dispensable-items": {
		area: "equipment",
		key: "Dispensable Items",
	},
	"/asset-sentinel/equipment-funding-sources": {
		area: "equipment",
		key: "Funding Sources",
	},
	"/asset-sentinel/equipment-code-maintenance/equipment-types": {
		area: "codes",
		key: "Equipment Types",
	},
	"/asset-sentinel/equipment-code-maintenance/equipment-status": {
		area: "codes",
		key: "Equipment Statuses",
	},
	"/asset-sentinel/equipment-code-maintenance/equipment-conditions": {
		area: "codes",
		key: "Equipment Conditions",
	},
	"/asset-sentinel/equipment-code-maintenance/equipment-category": {
		area: "codes",
		key: "Equipment Category Codes",
	},
	"/asset-sentinel/equipment-code-maintenance/equipment-service-requirements":
		{ area: "codes", key: "Equipment Service Requirements" },
};
